export const logoFM = 'https://group-financeiro-prod.s3.sa-east-1.amazonaws.com/public/fm_logo.png';

export const logoGF = 'https://group-financeiro-prod.s3.sa-east-1.amazonaws.com/public/gf_logo.png';
